"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _KeyStore = require("crm_data/store/KeyStore");

var _default = (0, _KeyStore.defineKeyStore)({
  namespace: _ActionNamespaces.COMMUNICATOR,
  getInitialState: function getInitialState() {
    return (0, _immutable.Map)({
      interaction: null,
      isMinimized: false,
      isFullScreen: false,
      initialContent: (0, _immutable.Map)(),
      iframeDimensions: 'windowed'
    });
  },
  idIsValid: function idIsValid(id) {
    return typeof id === 'string';
  }
}).defineResponseTo(_ActionTypes.SHOW_COMMUNICATOR, function (state, type) {
  var currentInteractionType = state.get('interaction');

  if (currentInteractionType !== type || state.get('isMinimized') || state.get('isFullScreen')) {
    return state.merge({
      interaction: type,
      isMinimized: false,
      isFullScreen: false
    });
  }

  return state;
}).defineResponseTo(_ActionTypes.SET_COMMUNICATOR_TRIGGER_LOCATION, function (state, triggeredLocationContext) {
  triggeredLocationContext = triggeredLocationContext || {
    triggerLocation: null,
    subjectIdContext: null,
    objectTypeContext: null
  };
  return state.merge({
    triggerLocation: triggeredLocationContext.triggerLocation,
    subjectIdContext: triggeredLocationContext.subjectIdContext,
    objectTypeContext: triggeredLocationContext.objectTypeContext
  });
}).defineResponseTo(_ActionTypes.HIDE_COMMUNICATOR, function (state) {
  return state.set('interaction', null);
}).defineResponseTo(_ActionTypes.NAVIGATE, function (state) {
  return state.set('interaction', null).set('triggerLocation', null).set('subjectIdContext', null).set('objectTypeContext', null);
}).defineResponseTo(_ActionTypes.MINIMIZE_COMMUNICATOR, function (state) {
  return state.set('isMinimized', true).set('isFullScreen', false);
}).defineResponseTo(_ActionTypes.MAXIMIZE_COMMUNICATOR, function (state) {
  return state.set('isMinimized', false);
}).defineResponseTo(_ActionTypes.OPEN_FULLSCREEN_COMMUNICATOR, function (state) {
  return state.set('isFullScreen', true).set('isMinimized', false);
}).defineResponseTo(_ActionTypes.CLOSE_FULLSCREEN_COMMUNICATOR, function (state) {
  return state.set('isFullScreen', false);
}).defineResponseTo(_ActionTypes.SET_COMMUNICATOR_INITIAL_CONTENT, function (state, _ref) {
  var type = _ref.type,
      content = _ref.content;
  return state.setIn(['initialContent', type], content);
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;